import { Meal } from '../Meal/types';

export const getCategories = (meals: Meal[], segmentId: string): string[] => {
	const categories = new Set<string>();

	meals.forEach(meal => {
		if (meal.segmentsId.indexOf(segmentId) !== -1 && !categories.has(meal.category)) {
			categories.add(meal.category);
		}
	});

	return [...categories];
};

export const getSegmentsWithMeal = (meals: Meal[]): Set<string> => {
	const segmentsWithMeal = new Set<string>();

	meals.forEach(meal => meal.segmentsId.forEach(segmentId => segmentsWithMeal.add(segmentId)));

	return segmentsWithMeal;
};

export const removeDuplicatesByName = (meals: Meal[]) => {
	return Array.from(
		meals
			.reduce((meals, meal) => {
				const uncapitalizedName = meal.name.toLowerCase();

				if (!meals.has(uncapitalizedName)) {
					meals.set(uncapitalizedName, meal);
				}

				return meals;
			}, new Map())
			.values()
	);
};
